export interface JournalParsed {
  issueId: string
  volume: string
  issue: string
}

const JOURNAL_VOLUME_ISSUE_REGEX =
  /^([\d.]+\/[^/]+\/volum-(\d+)\/utgave-(\d+(?:-\d+){0,2}))(?:\/|$)/

/**
 * Parses journal IDs like:
 * - "10.18261/issn.1504-3126/volum-15/utgave-2/artikkel-1"
 * - "10.18261/issn.1504-3126/volum-15/utgave-2/artikkel-1/section-1"
 * - "10.18261/pol/volum-15/utgave-2/artikkel-1/"
 * - "10.18261/pol/volum-15/utgave-2-3-2025/artikkel-1/"
 *
 * Returns:
 * - issueId: "10.18261/.../volum-15/utgave-2-3-2025"
 * - volume: "15"
 * - issue: "2-3-2025"
 */
export function parseJournalIssueFromId(id: string): JournalParsed | null {
  if (!id) {
    return null
  }

  const [, issueId, volume, issue] = id.match(JOURNAL_VOLUME_ISSUE_REGEX) ?? []
  if (!issueId || !volume || !issue) {
    return null
  }

  return {
    issueId,
    volume,
    issue,
  }
}
